export const content: any = {
  //comum
  urbana: "Zona Urbana",
  rural: "Zona Rural",
  sim: "Sim",
  nao: "Não",
  masc: "Masculino",
  fem: "Feminino",
  masculino: "Masculino",
  feminino: "Feminino",
  indefinido: "Indefinido",
  "nao-informado": "Não informado",
  total: "Total",

  "1-meses": "1 mês",
  "2-meses": "2 meses",
  "3-meses": "3 meses",
  "4-meses": "4 meses",
  "6-meses": "6 meses",
  "9-meses": "9 meses",
  "12-meses": "12 meses",

  "60-a-64-anos": "60 a 64 anos",
  "65-a-69-anos": "65 a 69 anos",
  "70-a-74-anos": "70 a 74 anos",
  "75-a-79-anos": "75 a 79 anos",
  "80-a-84-anos": "80 a 84 anos",
  "85-a-89-anos": "85 a 89 anos",
  "90-a-94-anos": "90 a 94 anos",
  "95-a-99-anos": "95 a 99 anos",
  "100-ou-mais": "100+ anos",

  amarela: "Amarela",
  parda: "Parda",
  branca: "Branca",
  indigena: "Indígena",
  preta: "Preta",

  normal: "Normal",
  "baixo-peso": "Baixo Peso",
  "excesso-peso": "Excesso de Peso",

  vacinadas: "Vacinadas",
  "nao-vacinadas": "Não\nVacinadas",

  atendidas: "Atendidas",
  "nao-atendidas": "Sem\natendimento",

  hipertensao: "Hipertensão",
  diabetes: "Diabetes",
  "hipertensao-diabetes-associadas": "Hipertensão\ne Diabetes\nAssociadas",

  //tabagismo
  "proporcao-tabagistas-acompanhadas":
    "Proporção de pessoas tabagistas acompanhadas",
  "total-pessoas-acompanhadas": "Total de pessoas acompanhadas",
  "total-pessoas": "Total de pessoas",
  "tabagistas-faixa-etaria": "Pessoas tabagistas por faixa etária",
  "pessoas-tabagistas-sexo": "Pessoas tabagistas por sexo",
  "proporcao-fatores-riscos-por-dant":
    "Proporçao dos fatores de risco por condições crônicas entre tabagistas",
  "consulta-odontologica-tabagistas":
    "Proporção de consultas odontológicas entre pessoas tabagistas",
  "pessoas-tabagistas-escolaridade": "Pessoas tabagistas por escolaridade",
  "acompanhadas-ubs-nao-tabagistas":
    "Pessoas acompanhadas \n na UBS não tabagistas",
  "acompanhadas-ubs-tabagistas": "Pessoas tabagistas \nacompanhadas na UBS",
  "doenca-cardiovascular": "Doença\nCardiovascular",
  cancer: "Câncer",
  "diabetes-melitus": "Diabetes\n Melitus",
  "doenca-respiratoria-cronica": "Doença\nRespiratória\nCrônica",
  "ate-30": "até 30 anos",
  "ate-40": "31 a 40 anos",
  "ate-50": "41 a 50 anos",
  analfabeto: "Analfabeto",
  "primeiro-grau-completo": "1º grau\ncompleto",
  "primeiro-grau-incompleto": "1º grau\nincompleto",

  //relatorio de qualidade
  "total-cadastros-ubs": "Total de cadastros na Unidade Básica de Saúde",
  "porcentagem-cadastros-atualizados": "Porcentagem de cadastros atualizados*",
  "total-cadastros-cidadaos-por-tipo-identificacao":
    "Total de cadastros de cidadãos por tipo de identificação",
  "total-cidadaos-conforme-situação-cadastral":
    "Total de cadastros de cidadãos conforme situação cadastral",
  "localizacao-imoveis-cadastrados":
    "Cidadãos cadastrados por tipo de localização do imóvel",
  "total-cidadaos-acompanhados":
    "Total de cadastros de cidadãos conforme situação de acompanhamento",
  "total-cadastros-pessoas-raca-cor":
    "Total de cadastros de cidadãos conforme raça/cor",
  "sem-cpf-cnf": "sem CPF e CNS",
  "cadastros-identificados-por-cpf-cns":
    "Cadastros identificados\npor CPF e/ou CNS",
  ativo: "Cadastro Ativo",
  inconsistente: "Cadastro Inativo",
  "total-cadastros": "Total de cadastros",
  fci: "Ficha de Cadastro\nIndividual (FCI)",
  pec: "Módulo Cidadão\n(PEC)",
  recusa: "Recusa de\nCadastro (FCI)",

  // relatorio desenvolvimento infantil
  "total-criancas-cadastradas-2-anos":
    "Total de crianças até 2 anos cadastradas",
  "total-criancas-atendidas-2-anos": "Total de crianças até 2 anos atendidas",
  "total-cadastros-criancas-raca-cor":
    "Total de cadastros de crianças por raça e cor",
  "total-extratificacao-por-profissional":
    "Extratificação de atendimentos por profissional",
  "distribuicao-criancas-sexo": "Distribuição de crianças por sexo",
  "distribuicao-criancas-faixa-etaria":
    "Distribuição de crianças por faixa etária",
  "distribuicao-criancas-local":
    "Distribuição de crianças por local de moradia",

  //idosas
  "total-idosas-ubs": "Total de pessoas idosas na UBS",
  "total-raca-cor": "Total de cadastros de pessoas idosas por raça e cor",
  "total-imc": "Total de pessoas idosas de acordo com o IMC",
  "total-proporcao-vacina-influenza":
    "Proporção de pessoas idosas com registro de vacina Influenza",
  "total-proporcao-atendimento-odonto":
    "Proporção de pessoas idosas com atendimento odontológico",
  "pessoas-por-faixa-etaria": "Pessoas idosas por faixa etária",
  "pessoas-por-sexo": "Pessoas idosas por sexo",
  "pessoas-por-diagnostico": "Proporção de pessoas idosas com diagnóstico de:",
};
